<div class="flex-row">
  <div class="chart-container">
    <div class="flex-row" *ngIf="displayAll">

      <div class="box border flex-row-item flex-direction-column flex-justify-content-space-between"
        [style.flex]="dashboard.getMeasurementPeriod()">
        <div class="month-label">
          <div>{{ dashboard.getMeasurementStartDate() | moment : 'D MMM YYYY' : locale }}</div>
        </div>
        <div class="text-align-center">
          <div class="margin-bottom-half">{{ 'D24' | translate : locale }}</div>
          <div class="period-box measurement-period-box">
            {{ dashboard.getMeasurementStartDate() | moment : 'D MMM' : locale }} - {{ dashboard.getMeasurementEndDate()
            | moment : 'D MMM YYYY' : locale }}
            <ng-template ngFor [ngForOf]="[].constructor(dashboard.getMeasurementPeriod())" let-i="index"
              let-last="last">
              <div class="month-ticker" [style.left.%]="i * 100 / dashboard.getMeasurementPeriod()!"
                [style.width.%]="100 / dashboard.getMeasurementPeriod()!" *ngIf="!last">
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="box border flex-row-item flex-direction-column flex-justify-content-space-between"
        [style.flex]="dashboard.getDiscountPeriod()">
        <div class="marker-container flex-row-item flex-justify-content-space-between"
          [style.margin-left]="isOffsetZero ? '0' : null">
          <div class="month-label">
            <div>{{ dashboard.getDiscountStartDate() | moment : 'D MMM' : locale }}</div>
          </div>
          <div class="month-label" *ngIf="isOffsetZero">
            {{ dashboard.getNextDiscountEndDate() | moment : 'D MMM YYYY' : locale }}
          </div>
          <div class="marker"
            [ngClass]="{ 'right': leftPercentage >= rightPercentage, 'left': rightPercentage > leftPercentage }"
            [ngStyle]="{ 'right': leftPercentage >= rightPercentage ? rightPercentage+'%' : '', 'left': rightPercentage > leftPercentage ? leftPercentage+'%' : ''}"
            [hidden]="leftPercentage === -1 || rightPercentage === -1">
            <div class="date">{{ reportDate | moment : 'D MMM' : locale }}</div>
          </div>
        </div>
        <div class="text-align-center">
          <div class="margin-bottom-half">{{ 'D7' | translate : locale }}</div>
          <div class="period-box current discount-period-box">
            {{ dashboard.getDiscountStartDate()! | moment : 'D MMM' : locale }} - {{ dashboard.getDiscountEndDate()! |
            moment :'D MMM YYYY' : locale }}
            <ng-template ngFor [ngForOf]="[].constructor(dashboard.getDiscountPeriod())" let-i="index" let-last="last">
              <div class="month-ticker" [style.left.%]="i * 100 / dashboard.getDiscountPeriod()!"
                [style.width.%]="100 / dashboard.getDiscountPeriod()!" *ngIf="!last">
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="box border flex-row-item flex-justify-content-space-between" [style.flex]="currentPeriodsOffset"
        *ngIf="!isOffsetZero">
        <div class="month-label">
          {{ discountEndNextDay | moment : 'D MMM' : locale }}
        </div>
        <div class="month-label">{{ dashboard.getNextDiscountEndDate() | moment : 'D MMM YYYY' : locale }}</div>
      </div>

    </div>

    <div class="flex-row"
      *ngIf="dashboard.getActiveRampUpPeriodFlag() ==='Y' || dashboard.getActiveInitialDiscountPeriodFlag() === 'Y'">
      <div class="box border flex-row-item flex-direction-column flex-justify-content-space-between"
        [style.flex]="dashboard.getRampUpPeriod()">
        <div class="month-label" *ngIf="dashboard.getActiveRampUpPeriodFlag() === 'N'">
          <div>{{ dashboard.getRampUpStartDate() | moment : 'D MMM' : locale }}</div>
        </div>
        <div class="marker-container" *ngIf="dashboard.getActiveRampUpPeriodFlag() === 'Y'">
          <div class="month-label">
            <div>{{ dashboard.getRampUpStartDate() | moment : 'D MMM' : locale }}</div>
          </div>
          <div class="marker"
            [ngClass]="{ 'right': leftPercentage >= rightPercentage, 'left': rightPercentage > leftPercentage }"
            [ngStyle]="{ 'right': leftPercentage >= rightPercentage ? rightPercentage+'%' : '', 'left': rightPercentage > leftPercentage ? leftPercentage+'%' : ''}"
            [hidden]="leftPercentage === -1 || rightPercentage === -1">
            <div class="date">{{ reportDate | moment : 'D MMM' : locale }}</div>
          </div>
        </div>
        <div class="text-align-center">
          <div class="margin-bottom-half">{{ 'D9' | translate : locale }}</div>
          <div class="period-box measurement-period-box">
            {{ dashboard.getRampUpStartDate() | moment : 'D MMM' : locale }} - {{ dashboard.getRampUpEndDate() | moment
            : 'D MMM YYYY' : locale }}
            <ng-template ngFor [ngForOf]="[].constructor(dashboard.getRampUpPeriod())" let-i="index" let-last="last">
              <div class="month-ticker" [style.left.%]="i * 100 / dashboard.getRampUpPeriod()!"
                [style.width.%]="100 / dashboard.getRampUpPeriod()!" *ngIf="!last">
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="box border flex-row-item flex-direction-column flex-justify-content-space-between"
        [style.flex]="dashboard.getInitialDiscountPeriod()">
        <div class="month-label" *ngIf="dashboard.getActiveInitialDiscountPeriodFlag() === 'N'">
          <div>{{ dashboard.getInitialDiscountStartDate() | moment : 'D MMM' : locale }}</div>
        </div>
        <div class="marker-container" *ngIf="dashboard.getActiveInitialDiscountPeriodFlag() === 'Y'">
          <div class="month-label">
            <div>{{ dashboard.getInitialDiscountStartDate() | moment : 'D MMM' : locale }}</div>
          </div>
          <div class="marker"
            [ngClass]="{ 'right': leftPercentage >= rightPercentage, 'left': rightPercentage > leftPercentage }"
            [ngStyle]="{ 'right': leftPercentage >= rightPercentage ? rightPercentage+'%' : '', 'left': rightPercentage > leftPercentage ? leftPercentage+'%' : ''}"
            [hidden]="leftPercentage === -1 || rightPercentage === -1">
            <div class="date">{{ reportDate | moment : 'D MMM' : locale }}</div>
          </div>
        </div>

        <div class="text-align-center">
          <div class="margin-bottom-half">{{ 'D8' | translate : locale }}</div>
          <div class="period-box measurement-period-box">
            {{ dashboard.getInitialDiscountStartDate() | moment : 'D MMM' : locale }} - {{
            dashboard.getInitialDiscountEndDate() | moment : 'D MMM YYYY' : locale }}
            <ng-template ngFor [ngForOf]="[].constructor(dashboard.getInitialDiscountPeriod())" let-i="index"
              let-last="last">
              <div class="month-ticker" [style.left.%]="i * 100 / dashboard.getInitialDiscountPeriod()!"
                [style.width.%]="100 / dashboard.getInitialDiscountPeriod()!" *ngIf="!last">
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="box border flex-row-item flex-justify-content-space-between" [style.flex]="getCurrentPeriodOffset()">
        <div class="month-label">
          {{ getMonthAfterInitialDiscountEnd() | moment : 'D MMM' : locale }}
        </div>
        <div class="month-label">{{ dashboard.getNextDiscountEndDate() | moment : 'D MMM YYYY' : locale }}</div>
      </div>

    </div>

    <div class="flex-row margin-top-half" *ngIf="displayOnlyNextPeriods">
      <div class="flex-row-item" [style.flex]="getNextPeriodOffset()"></div>

      <div class="flex-row-item flex-direction-column text-align-center"
        [style.flex]="dashboard.getNextMeasurementPeriod()">
        <div class="period-box measurement-period-box">
          {{ dashboard.getNextMeasurementStartDate() | moment : 'D MMM' : locale }} - {{
          dashboard.getNextMeasurementEndDate() | moment : 'D MMM YYYY' : locale }}
          <ng-template ngFor [ngForOf]="[].constructor(dashboard.getNextMeasurementPeriod())" let-i="index"
            let-last="last">
            <div class="month-ticker" [style.left.%]="i * 100 / dashboard.getNextMeasurementPeriod()!"
              [style.width.%]="100 / dashboard.getNextMeasurementPeriod()!" *ngIf="!last">
            </div>
          </ng-template>
        </div>
        <div class="font-color-grey margin-top-half">{{ 'D25' | translate : locale }}</div>
      </div>

      <div class="flex-row-item flex-direction-column text-align-center"
        [style.flex]="dashboard.getNextDiscountPeriod()">
        <div class="period-box discount-period-box">
          {{ dashboard.getNextDiscountStartDate() | moment : 'D MMM' : locale }} - {{ dashboard.getNextDiscountEndDate()
          | moment : 'D MMM YYYY' : locale }}
          <ng-template ngFor [ngForOf]="[].constructor(dashboard.getNextDiscountPeriod())" let-i="index"
            let-last="last">
            <div class="month-ticker" [style.left.%]="i * 100 / dashboard.getNextDiscountPeriod()!"
              [style.width.%]="100 / dashboard.getNextDiscountPeriod()!" *ngIf="!last">
            </div>
          </ng-template>
        </div>
        <div class="font-color-grey margin-top-half">{{ 'D26' | translate : locale }}</div>
      </div>

    </div>
  </div>
  <div class="final-border" *ngIf="displayAll">
  </div>
</div>